import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import EventLogDTO from '../../../adapters/dto/eventLog/EventLogDTO';
import { formatDate } from '../../../utils/dateUtils';
import UserName from '@src/components/user/UserName';

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '80vh',
}));

const Row = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(3),
}));

const Info = styled(Box)(({ theme }) => ({
  width: '50%',
}));

const Title = styled(Box)(({ theme }) => ({
  paddingBottom: '10px',
}));

interface Props {
  eventLog: EventLogDTO | undefined;
}

function Details({ eventLog }: Props) {
  return (
    <>
      {eventLog && (
        <Container>
          <Typography variant="h5">Details</Typography>
          <Row>
            <Info>
              <Title>
                <Typography variant="subtitle2">Time</Typography>
              </Title>
              <Typography variant="body2">
                {eventLog.createdAt && formatDate(eventLog.createdAt, 'HH:mm')}
              </Typography>
            </Info>
            <Info>
              <Title>
                <Typography variant="subtitle2">Date</Typography>
              </Title>
              <Typography variant="body2">
                {eventLog.createdAt &&
                  formatDate(eventLog.createdAt, 'DD/MM/YYYY')}
              </Typography>
            </Info>
          </Row>
          <Row>
            <Info>
              <Title>
                <Typography variant="subtitle2">User</Typography>
              </Title>
              <UserName id={eventLog.createdById} />
            </Info>
          </Row>
          <Row>
            <Info>
              <Title>
                <Typography variant="subtitle2">Event Group</Typography>
              </Title>
              <Typography variant="body2">{eventLog.group}</Typography>
            </Info>
            <Info>
              <Title>
                <Typography variant="subtitle2">Event Name</Typography>
              </Title>
              <Typography variant="body2">
                {eventLog.name.split('_').slice(1).join(' ')}
              </Typography>
            </Info>
          </Row>
          <Row>
            <Info>
              <Title>
                <Typography variant="subtitle2">Event Text</Typography>
              </Title>
              <Typography variant="body2">{eventLog.text}</Typography>
            </Info>
          </Row>
        </Container>
      )}
    </>
  );
}

export default Details;
